import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function atLeastOneRequired(fieldNamesLists: string[][]) {
    return (formGroup: UntypedFormGroup): ValidationErrors | null => {
        return (fieldNamesLists?.length) &&
            fieldNamesLists.some(fieldNames => {
                return (fieldNames?.every(fieldName => formGroup.get(fieldName)?.value));
            })
            ? null
            : ({ atLeastOneRequired: 'need to peek one of the fields!' });
    };
}
